module.exports = "/_next/static/images/6c9fc7c88be42a0f56df2cbf4fb0d286-people-smile-at-home-md@3x.jpg";